<ln-ln-image-frame
  [src]="imageUrl"
  [alt]="'imagesAlt.artisan' | transloco"
  [class]="
    'mx-auto flex h-[231px] w-full max-w-[383px] flex-row rounded-[10px] object-cover sm:h-[643px] sm:max-w-[1305px] sm:rounded-[50px]'
  "></ln-ln-image-frame>
